module.exports = __webpack_public_path__ + "static/media/equivalence-water.39b27bd3.svg";